import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    status: null,
    error: null,
    userProfile: {},
    fullname: null,
    isLoggedIn: false,
    isHomePage: false,
    token: null,
    sentRequest: null,
    isLoading: false,
    dataLoading: {},
    role: null,
    permission: null,
    unsaveChange: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setFullname(state, payload) {
      state.fullname = payload
    },
    removeUser(state) {
      state.user = null
    },
    setStatus(state, payload) {
      state.status = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload
    },
    setIsHomePage(state, payload) {
      state.isHomePage = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setSentRequest(state, payload) {
      state.sentRequest = payload
    },
    setRole(state, payload) {
      state.role = payload
    },
    setPermission(state, payload) {
      state.permission = payload
    },
    setDataLoading(state, payload) {
      state.dataLoading = payload
    },
    setLoading(state, payload) {
      state.isLoading = payload
    },
    clearUnsavedChange(state) {
      state.unsaveChange = null
    }
  },
  getters: {
    status(state) {
      return state.status
    },
    user(state) {
      return state.user
    },
    fullname(state) {
      return state.fullname
    },
    isLoggedIn(state) {
      return state.isLoggedIn
    },
    error(state) {
      return state.error
    },
    isHomePage(state) {
      return state.isHomePage
    },
    token(state) {
      return state.token
    },
    sentRequest(state) {
      return state.sentRequest
    },
    role(state) {
      return state.role
    },
    permission(state) {
      return state.permission
    },
    isLoading(state) {
      return state.isLoading
    },
    dataLoading(state) {
      return state.dataLoading
    },
    unsaveChange(state) {
      return state.unsaveChange
    }
  }
})
